<template>
  <div class="mine">
    <el-container>
      <el-aside width="240px">
        <el-menu :default-active="activeMenuIndex" class="el-menu-vertical-demo">
          <el-menu-item index="1" v-pre-handle-on-demand="()=>toPath('/mine/favorite')">
            <i class="el-icon-menu"></i>
            <span slot="title">我的收藏</span>
          </el-menu-item>
          <el-menu-item index="2" v-pre-handle-on-demand="()=>toPath('/mine/history')">
            <i class="el-icon-document"></i>
            <span slot="title">浏览记录</span>
          </el-menu-item>
          <router-link to="/mine/setting" tag="div">
            <el-menu-item index="3">
              <i class="el-icon-setting"></i>
              <span slot="title">个人设置</span>
            </el-menu-item>
          </router-link>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Mine',
  data() {
    return {
      activeMenuIndex: '0'
    }
  },
  created() {
    const routePath = this.$route.path
    if (routePath === '/mine/favorite') {
      this.activeMenuIndex = '1'
    } else if (routePath === '/mine/history') {
      this.activeMenuIndex = '2'
    } else if (routePath === '/mine/setting') {
      this.activeMenuIndex = '3'
    } else {
      this.activeMenuIndex = '0'
    }
  },
  watch: {
    $route(to) {
      const routePath = to.path
      if (routePath === '/mine/favorite') {
        this.activeMenuIndex = '1'
      } else if (routePath === '/mine/history') {
        this.activeMenuIndex = '2'
      } else if (routePath === '/mine/setting') {
        this.activeMenuIndex = '3'
      } else {
        this.activeMenuIndex = '0'
      }
    }
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path: path
      });
    }
  }
}
</script>

<style scoped lang="stylus">
.mine {
  .el-container {
    height: calc(100vh - 72px);
    padding-top: 15px;
    background-color: #EEF5FE;

    .el-aside {
      background: #fff;
      overflow-y: auto;
      border-top-right-radius: 10px;
      padding-top: 20px;

      .el-menu {
        border-right: none;
      }
    }

    .el-main {
      margin: 0 15px 15px;
      background: #fff;
      overflow-y: auto;
      border-top-left-radius: 10px;
    }
  }
}
</style>